/* istanbul ignore file */
import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import {
  CheckboxGroupWithSelectAllLayoutProps,
  CheckboxInput,
} from 'ui-builder';
import { cn } from 'shadcn-ui';
import Label from '../form/layout/Label';
import ErrorsWrapper from '../form/input/layout/ErrorsWrapper';

function LegacyCheckboxGroupWithSelectAllLayout(
  props: CheckboxGroupWithSelectAllLayoutProps,
) {
  return (
    <ErrorsWrapper name={props.name}>
      <div className={props.className}>
        <div className="flex items-center gap-2 mb-2">
          <Label label={props.label} bold />
          <button
            type="button"
            onClick={() => props.selectAllFunc()}
            className="text-xs text-blue-600 cursor-pointer bg-transparent border-none p-0"
          >
            Select All
          </button>
        </div>
        <div className="flex flex-col gap-2">
          {props.options.map((option) => {
            const labelComponent = props.optionLabelComponent
              ? <props.optionLabelComponent data={option._data} />
              : undefined;

            return (
              <div
                className={props.optionClassName}
                key={`checkbox-group-item-${props.name}-${option.value}`}
              >
                <CheckboxInput
                  source={`${props.name}-${option.value}`}
                  label={option.label}
                  labelComponent={labelComponent}
                  value={props.isSelectedFunc(option.value)}
                  onChangeCallback={() => {
                    if (props.isSelectedFunc(option.value)) {
                      props.unselectOptionFunc(option.value);
                    } else {
                      props.selectOptionFunc(option.value);
                    }
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </ErrorsWrapper>
  );
}

function ShadcnCheckboxGroupWithSelectAllLayout(
  props: CheckboxGroupWithSelectAllLayoutProps,
) {
  return (
    <ErrorsWrapper name={props.name}>
      <div className={props.className}>
        <div className="flex items-center gap-2 mb-2">
          {props.label && (
            <span className="text-sm font-semibold text-foreground">{props.label}</span>
          )}
          <button
            type="button"
            onClick={() => props.selectAllFunc()}
            className={cn(
              'text-xs text-primary hover:underline cursor-pointer bg-transparent border-none p-0',
              props.selectAllContainerClassName,
            )}
          >
            Select All
          </button>
        </div>
        <div className="flex flex-col gap-2">
          {props.options.map((option) => {
            const labelComponent = props.optionLabelComponent
              ? <props.optionLabelComponent data={option._data} />
              : undefined;

            return (
              <div
                className={props.optionClassName}
                key={`checkbox-group-item-${props.name}-${option.value}`}
              >
                <CheckboxInput
                  source={`${props.name}-${option.value}`}
                  label={option.label}
                  labelComponent={labelComponent}
                  value={props.isSelectedFunc(option.value)}
                  onChangeCallback={() => {
                    if (props.isSelectedFunc(option.value)) {
                      props.unselectOptionFunc(option.value);
                    } else {
                      props.selectOptionFunc(option.value);
                    }
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </ErrorsWrapper>
  );
}

export default function CheckboxGroupWithSelectAllLayout(
  props: CheckboxGroupWithSelectAllLayoutProps,
) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnCheckboxGroupWithSelectAllLayout {...props} />;
  } else {
    return <LegacyCheckboxGroupWithSelectAllLayout {...props} />;
  }
}
